import * as React from "react";
import { VIEWNAME } from "../../utils/GeneralUtils";
import AdvancedModeHeader from "../../components/Table/components/headerComponents/AdvancedModeHeader";
import StandardModeHeader from "../../components/Table/components/headerComponents/StandardModeHeader";

interface IModeltypeHeaderProps {
    inEditMode:boolean;
    viewName:VIEWNAME;
    hasReloadButton: true;
    isSelected: boolean;
    hasNewButton: boolean;
    hasCopyButton: boolean;
    hasDeleteButton: boolean;
    hasEditButton: boolean;
    hasCopyYearButton: boolean;
    hasHistoryButton: boolean;

    disabledNewButton: boolean;
    disabledCopyButton: boolean;
    disabledDeleteButton: boolean;
    disabledReloadButton: boolean;
    disableHistoryButton: boolean;

    labelNewButton: string;
    labelCopyButton: string;
    labelDeleteButton: string;
    labelEditButton: string;
    labelReloadButton: string;
    labelCopyYearButton: string;
    labelHistoryButton: string;
    iconNewButton: string;
    onClickNewButton(): void;
    onClickCopyButton(): void;
    onClickDeleteButton(): void;
    onClickEditButton(): void;
    onClickReloadButton(): void;
    onClickHistoryButton(): void;

    switchHeaderMode: boolean;
    btnActiveDeactiveIcon?: string;
    disabledActiveInactiveButton?: boolean;
    labelActiveInactiveButton?:string;
    onClickActiveDeactiveButton?():void;
    hasCheckPCCDSyncronisationButton?:boolean;
    onClickCheckPCCDSyncronisationButton?:()=>void;
    disableCheckPCCDSyncronisationButton?:boolean;
    labelCheckPCCDSyncronisationButton?:string;
    hasAsisigmantsAction?:boolean;
}

/** displays button bar header with divider */
const ModeltypeHeader: React.SFC<IModeltypeHeaderProps> = (props: IModeltypeHeaderProps) => {
    return (
        <div className='action-header-container display--flex align-items--center' style={{padding: "5px 10px"}}>
            {props.switchHeaderMode ?
                <AdvancedModeHeader {...props} /> :
                <StandardModeHeader  {...props} />
            }
        </div>
    );
};

export default ModeltypeHeader;



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModeltypeHeader.tsx